@let s = pageState();
@if (s.kind === 'pending') {
  <app-marketing-header variant="home" />
  <p class="text-center py-24">Loading…</p>
} @else if (s.kind === 'error') {
  <div class="cg-container--marketing py-16 text-center">
    <h1>Category not found</h1>
    <a routerLink="/blogs" class="cg-mkt-btn cg-mkt-btn--primary mt-6 inline-block">All blogs</a>
  </div>
} @else {
  <div class="bg-slate-50 min-h-screen">
    <app-marketing-header variant="home" />
    <main class="cg-mkt-list-page">
      <div class="cg-container--marketing">
        <app-marketing-section-heading
          [eyebrow]="'Category'"
          [title]="s.page.category.name"
          [subtitle]="s.page.category.description ?? s.page.seo.description"
        />
        <div class="cg-blog-grid">
          @for (item of s.page.items; track item.slug) {
            <app-marketing-blog-card [post]="item" />
          }
        </div>
      </div>
    </main>
    <app-marketing-footer />
  </div>
}
